// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MasterSection-module__font-s-10___tAPn8 {
  font-size: 10px !important;
}

.MasterSection-module__font-s-12___sUOR9 {
  font-size: 12px !important;
}

.MasterSection-module__font-s-13___OYqcp {
  font-size: 13px !important;
}

.MasterSection-module__font-s-14___kt9JT {
  font-size: 14px !important;
}

.MasterSection-module__font-s-15___qpr7g {
  font-size: 15px !important;
}

.MasterSection-module__font-s-16___tKMh0 {
  font-size: 16px !important;
}

.MasterSection-module__font-s-18___IKPEK {
  font-size: 18px !important;
}

.MasterSection-module__font-s-20___bmAUm {
  font-size: 20px !important;
}

.MasterSection-module__font-s-22___UwKVe {
  font-size: 22px !important;
}

.MasterSection-module__font-s-28___tVl2a {
  font-size: 28px !important;
}

.MasterSection-module__font-w-400___hP3Kh {
  font-weight: 400 !important;
}

.MasterSection-module__font-w-500___fJC6B {
  font-weight: 500 !important;
}

.MasterSection-module__font-w-600___sqxeL {
  font-weight: 600 !important;
}

.MasterSection-module__font-w-700___lwcFj {
  font-weight: 700 !important;
}

.MasterSection-module__p-5___MeR0w {
  padding: 5px !important;
}

.MasterSection-module__p-12___lgkte {
  padding: 12px !important;
}

.MasterSection-module__p-16___zauQ3 {
  padding: 16px !important;
}

.MasterSection-module__p-30___bHZMx {
  padding: 30px !important;
}

.MasterSection-module__p-b-0___mzZfW {
  padding-bottom: 0 !important;
}

.MasterSection-module__p-b-5___F9Td6 {
  padding-bottom: 5px !important;
}

.MasterSection-module__p-b-10___pmOvH {
  padding-bottom: 10px !important;
}

.MasterSection-module__p-b-12___qrEFu {
  padding-bottom: 12px !important;
}

.MasterSection-module__p-b-16___Ma5NT {
  padding-bottom: 16px !important;
}

.MasterSection-module__p-b-18___BKxXi {
  padding-bottom: 18px !important;
}

.MasterSection-module__p-b-20___IDjHt {
  padding-bottom: 20px !important;
}

.MasterSection-module__p-b-25___a0bDK {
  padding-bottom: 25px !important;
}

.MasterSection-module__p-b-30___GjR64 {
  padding-bottom: 30px !important;
}

.MasterSection-module__p-b-50___KxUJ7 {
  padding-bottom: 50px !important;
}

.MasterSection-module__p-t-0___jWhR0 {
  padding-top: 0 !important;
}

.MasterSection-module__p-t-12___wObbL {
  padding-top: 12px !important;
}

.MasterSection-module__p-t-16___u0Klm {
  padding-top: 16px !important;
}

.MasterSection-module__p-t-18___phkNx {
  padding-top: 18px !important;
}

.MasterSection-module__p-t-20___hAusw {
  padding-top: 20px !important;
}

.MasterSection-module__p-t-30___Iu5Gk {
  padding-top: 30px !important;
}

.MasterSection-module__p-t-40___KnUbK {
  padding-top: 40px !important;
}

.MasterSection-module__p-t-50___vLKlj {
  padding-top: 50px !important;
}

.MasterSection-module__p-l-20___sOkdQ {
  padding-left: 20px !important;
}

.MasterSection-module__p-l-30___Vcox_ {
  padding-left: 30px !important;
}

.MasterSection-module__p-l-40___g6adI {
  padding-left: 40px !important;
}

.MasterSection-module__p-r-16___vWh0q {
  padding-right: 16px !important;
}

.MasterSection-module__p-r-20___fcaiJ {
  padding-right: 20px !important;
}

.MasterSection-module__p-r-30___eVNt3 {
  padding-right: 30px !important;
}

.MasterSection-module__p-r-50___tgd9D {
  padding-right: 50px !important;
}

.MasterSection-module__p-r-60___t7U1a {
  padding-right: 60px !important;
}

.MasterSection-module__m-b-1___GP4vK {
  margin-bottom: 1px !important;
}

.MasterSection-module__m-b-2___FwIIe {
  margin-bottom: 2px !important;
}

.MasterSection-module__m-b-6___G4i7n {
  margin-bottom: 6px !important;
}

.MasterSection-module__m-b-8___JybYA {
  margin-bottom: 8px !important;
}

.MasterSection-module__m-b-10___yBuVi {
  margin-bottom: 10px !important;
}

.MasterSection-module__m-b-14___i32AN {
  margin-bottom: 14px !important;
}

.MasterSection-module__m-b-16___F4lfT {
  margin-bottom: 16px !important;
}

.MasterSection-module__m-b-20___dIdfk {
  margin-bottom: 20px !important;
}

.MasterSection-module__m-b-22___weVzt {
  margin-bottom: 22px !important;
}

.MasterSection-module__m-b-24___iIkyA {
  margin-bottom: 24px !important;
}

.MasterSection-module__m-b-30___yOTB2 {
  margin-bottom: 30px !important;
}

.MasterSection-module__m-b-32___RVvRT {
  margin-bottom: 32px !important;
}

.MasterSection-module__m-b-40___CQ86R {
  margin-bottom: 40px !important;
}

.MasterSection-module__m-t-2____shka {
  margin-top: 2px !important;
}

.MasterSection-module__m-t-3___lNDMj {
  margin-top: 3px !important;
}

.MasterSection-module__m-t-4___mRHav {
  margin-top: 4px !important;
}

.MasterSection-module__m-t-5___RlOQd {
  margin-top: 5px !important;
}

.MasterSection-module__m-t-8___wTpZw {
  margin-top: 8px !important;
}

.MasterSection-module__m-t-10___hKxHd {
  margin-top: 10px !important;
}

.MasterSection-module__m-t-15___ZKOn8 {
  margin-top: 15px !important;
}

.MasterSection-module__m-t-16___MKWBJ {
  margin-top: 16px !important;
}

.MasterSection-module__m-t-20___qkzVZ {
  margin-top: 20px !important;
}

.MasterSection-module__m-t-22___ipJuH {
  margin-top: 22px !important;
}

.MasterSection-module__m-t-30___rxPGx {
  margin-top: 30px !important;
}

.MasterSection-module__m-t-32___bxKoD {
  margin-top: 32px !important;
}

.MasterSection-module__m-l-auto___IVIad {
  margin-left: auto !important;
}

.MasterSection-module__m-l-4___EUgty {
  margin-left: 4px !important;
}

.MasterSection-module__m-l-5___ZpCoQ {
  margin-left: 5px !important;
}

.MasterSection-module__m-l-6___qULSE {
  margin-left: 6px !important;
}

.MasterSection-module__m-l-8___WIzB0 {
  margin-left: 8px !important;
}

.MasterSection-module__m-l-10___wvp9K {
  margin-left: 10px !important;
}

.MasterSection-module__m-l-16___HEKa8 {
  margin-left: 16px !important;
}

.MasterSection-module__m-l-20___zqM_G {
  margin-left: 20px !important;
}

.MasterSection-module__m-l-24___wv1mZ {
  margin-left: 24px !important;
}

.MasterSection-module__m-l-30___fYOA1 {
  margin-left: 30px !important;
}

.MasterSection-module__m-l-35___JcBpY {
  margin-left: 35px !important;
}

.MasterSection-module__m-l-40___eAQoV {
  margin-left: 40px !important;
}

.MasterSection-module__m-r-8___QgJze {
  margin-right: 8px !important;
}

.MasterSection-module__m-r-10___w_u5q {
  margin-right: 10px !important;
}

.MasterSection-module__m-r-16___i2mZZ {
  margin-right: 16px !important;
}

.MasterSection-module__m-r-20___uN0OF {
  margin-right: 20px !important;
}

.MasterSection-module__m-r-24___tFEkU {
  margin-right: 24px !important;
}

.MasterSection-module__m-r-30___jrrHI {
  margin-right: 30px !important;
}

.MasterSection-module__m-r-40___vSzOv {
  margin-right: 40px !important;
}

.MasterSection-module__border-r-3___zsU0Q {
  border-radius: 3px !important;
}

.MasterSection-module__border-r-4___UZ_0W {
  border-radius: 4px !important;
}

.MasterSection-module__border-r-6___hJ4fT {
  border-radius: 6px !important;
}

.MasterSection-module__border-r-10___DPnd6 {
  border-radius: 10px !important;
}

.MasterSection-module__border-r-12___i66OM {
  border-radius: 12px !important;
}

.MasterSection-module__border-r-16___SiIyZ {
  border-radius: 16px !important;
}

.MasterSection-module__border-r-50___p32mp {
  border-radius: 50% !important;
}

.MasterSection-module__primary-border___RMdC_ {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterSection-module__primary-border-b___nPsTA {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterSection-module__primary-border-t___ZT4JX {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterSection-module__primary-border-l___YvJfT {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterSection-module__primary-border-r___QjYML {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterSection-module__secondary-border___J0oXG {
  border: 1px solid #637768;
}

.MasterSection-module__secondary-border-b___h0czq {
  border-bottom: 1px solid #637768;
}

.MasterSection-module__secondary-border-t___t9zbg {
  border-top: 1px solid #637768;
}

.MasterSection-module__secondary-border-l___PPS8N {
  border-left: 1px solid #637768;
}

.MasterSection-module__secondary-border-r___HC6Ch {
  border-right: 1px solid #637768;
}

.MasterSection-module__gap-0___iZqLD {
  gap: 0 !important;
}

.MasterSection-module__gap-2___tPyT_ {
  gap: 2px !important;
}

.MasterSection-module__gap-4___x14l8 {
  gap: 4px !important;
}

.MasterSection-module__gap-5___fuyVw {
  gap: 5px !important;
}

.MasterSection-module__gap-6___pMKCX {
  gap: 6px !important;
}

.MasterSection-module__gap-8___mdT8t {
  gap: 8px !important;
}

.MasterSection-module__gap-10___WIz90 {
  gap: 10px !important;
}

.MasterSection-module__gap-12___mf6m5 {
  gap: 12px !important;
}

.MasterSection-module__gap-14___L_32D {
  gap: 14px !important;
}

.MasterSection-module__gap-16___qzbv9 {
  gap: 16px !important;
}

.MasterSection-module__gap-18___lUpuk {
  gap: 18px !important;
}

.MasterSection-module__gap-20___RQKNR {
  gap: 20px !important;
}

.MasterSection-module__gap-24___YQG1n {
  gap: 24px !important;
}

.MasterSection-module__gap-26___N55Sz {
  gap: 26px !important;
}

.MasterSection-module__gap-30___ipN8b {
  gap: 30px !important;
}

.MasterSection-module__gap-32___zjFlc {
  gap: 32px !important;
}

.MasterSection-module__gap-40___yEyMD {
  gap: 40px !important;
}

.MasterSection-module__gap-50___u9JfN {
  gap: 50px !important;
}

.MasterSection-module__flex-1___C6wYU {
  flex: 1;
}

.MasterSection-module__flex-none___f7Pvv {
  flex: none !important;
}

.MasterSection-module__flex-column___RO4B0 {
  display: flex;
  flex-direction: column !important;
}

.MasterSection-module__flex-row___GW3om {
  display: flex;
  flex-direction: row !important;
}

.MasterSection-module__vertically-centered___qyBuJ {
  display: flex;
  align-items: center !important;
}

.MasterSection-module__horizontally-centered___yFGMf {
  display: flex;
  justify-content: center !important;
}

.MasterSection-module__horizontally-end___qaFtO {
  display: flex;
  justify-content: end !important;
}

.MasterSection-module__vertically-start___bAPYg {
  display: flex;
  align-items: start !important;
}

.MasterSection-module__space-between___N0i9w {
  display: flex;
  justify-content: space-between !important;
}

.MasterSection-module__flex-wrap___z8Zrj {
  flex-wrap: wrap !important;
}

.MasterSection-module__height-100___z5usi {
  height: 100%;
}

.MasterSection-module__width-50___CR6GA {
  width: 50% !important;
}

.MasterSection-module__width-100___PlTJk {
  width: 100%;
}

.MasterSection-module__cursor-pointer___oqq6l {
  cursor: pointer;
}

.MasterSection-module__cursor-not-allowed___CqG3s {
  cursor: not-allowed !important;
}

.MasterSection-module__absolute-centered___p6HNH {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MasterSection-module__absolute___D4krU {
  position: absolute;
}

.MasterSection-module__relative___uh8wa {
  position: relative;
}

.MasterSection-module__fixed___j1ssQ {
  position: fixed;
}

.MasterSection-module__visible___WhUEp {
  opacity: 1;
}

.MasterSection-module__invisible___xzDJ9 {
  opacity: 0;
}

.MasterSection-module__col-90___Qgd7p {
  width: 90% !important;
}

.MasterSection-module__col-auto___wr9SW {
  width: auto !important;
}

.MasterSection-module__medical-tabs___jt9go {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MasterSection-module__medical-table-new___HORtz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MasterSection-module__medical-table-new___HORtz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MasterSection-module__medical-table-new___HORtz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MasterSection-module__medical-table-new___HORtz::-webkit-scrollbar-track {
  display: none;
}
.MasterSection-module__medical-table-new___HORtz.MasterSection-module__no-pagination___k4cI9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MasterSection-module__medical-table-new___HORtz.MasterSection-module__no-pagination___k4cI9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MasterSection-module__medical-table-new___HORtz.MasterSection-module__no-pagination___k4cI9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MasterSection-module__medical-table-new___HORtz.MasterSection-module__no-pagination___k4cI9::-webkit-scrollbar-track {
  display: none;
}

.MasterSection-module__medical-table-empty___Ecw6n {
  padding: 14px 40px !important;
}

.MasterSection-module__icon-btn___xfp9c {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MasterSection-module__search-icon___ie3Oy {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MasterSection-module__disable-select___w9qOc {
  user-select: none;
}

.MasterSection-module__break-word___EKQza {
  word-break: break-word;
}

.MasterSection-module__popup-clear-btn___b6Oig {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MasterSection-module__scroll-m-b-20___O0V1U {
  scroll-margin-bottom: 20px;
}

.MasterSection-module__container___yqnhJ {
  width: 320px;
  background-color: #fcfbfb;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MasterDetailLayout/sections/MasterSection/MasterSection.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,yBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  width: 320px;\n  background-color: get-color(gray, ultra-light-gray);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MasterSection-module__font-s-10___tAPn8`,
	"fontS12": `MasterSection-module__font-s-12___sUOR9`,
	"fontS13": `MasterSection-module__font-s-13___OYqcp`,
	"fontS14": `MasterSection-module__font-s-14___kt9JT`,
	"fontS15": `MasterSection-module__font-s-15___qpr7g`,
	"fontS16": `MasterSection-module__font-s-16___tKMh0`,
	"fontS18": `MasterSection-module__font-s-18___IKPEK`,
	"fontS20": `MasterSection-module__font-s-20___bmAUm`,
	"fontS22": `MasterSection-module__font-s-22___UwKVe`,
	"fontS28": `MasterSection-module__font-s-28___tVl2a`,
	"fontW400": `MasterSection-module__font-w-400___hP3Kh`,
	"fontW500": `MasterSection-module__font-w-500___fJC6B`,
	"fontW600": `MasterSection-module__font-w-600___sqxeL`,
	"fontW700": `MasterSection-module__font-w-700___lwcFj`,
	"p5": `MasterSection-module__p-5___MeR0w`,
	"p12": `MasterSection-module__p-12___lgkte`,
	"p16": `MasterSection-module__p-16___zauQ3`,
	"p30": `MasterSection-module__p-30___bHZMx`,
	"pB0": `MasterSection-module__p-b-0___mzZfW`,
	"pB5": `MasterSection-module__p-b-5___F9Td6`,
	"pB10": `MasterSection-module__p-b-10___pmOvH`,
	"pB12": `MasterSection-module__p-b-12___qrEFu`,
	"pB16": `MasterSection-module__p-b-16___Ma5NT`,
	"pB18": `MasterSection-module__p-b-18___BKxXi`,
	"pB20": `MasterSection-module__p-b-20___IDjHt`,
	"pB25": `MasterSection-module__p-b-25___a0bDK`,
	"pB30": `MasterSection-module__p-b-30___GjR64`,
	"pB50": `MasterSection-module__p-b-50___KxUJ7`,
	"pT0": `MasterSection-module__p-t-0___jWhR0`,
	"pT12": `MasterSection-module__p-t-12___wObbL`,
	"pT16": `MasterSection-module__p-t-16___u0Klm`,
	"pT18": `MasterSection-module__p-t-18___phkNx`,
	"pT20": `MasterSection-module__p-t-20___hAusw`,
	"pT30": `MasterSection-module__p-t-30___Iu5Gk`,
	"pT40": `MasterSection-module__p-t-40___KnUbK`,
	"pT50": `MasterSection-module__p-t-50___vLKlj`,
	"pL20": `MasterSection-module__p-l-20___sOkdQ`,
	"pL30": `MasterSection-module__p-l-30___Vcox_`,
	"pL40": `MasterSection-module__p-l-40___g6adI`,
	"pR16": `MasterSection-module__p-r-16___vWh0q`,
	"pR20": `MasterSection-module__p-r-20___fcaiJ`,
	"pR30": `MasterSection-module__p-r-30___eVNt3`,
	"pR50": `MasterSection-module__p-r-50___tgd9D`,
	"pR60": `MasterSection-module__p-r-60___t7U1a`,
	"mB1": `MasterSection-module__m-b-1___GP4vK`,
	"mB2": `MasterSection-module__m-b-2___FwIIe`,
	"mB6": `MasterSection-module__m-b-6___G4i7n`,
	"mB8": `MasterSection-module__m-b-8___JybYA`,
	"mB10": `MasterSection-module__m-b-10___yBuVi`,
	"mB14": `MasterSection-module__m-b-14___i32AN`,
	"mB16": `MasterSection-module__m-b-16___F4lfT`,
	"mB20": `MasterSection-module__m-b-20___dIdfk`,
	"mB22": `MasterSection-module__m-b-22___weVzt`,
	"mB24": `MasterSection-module__m-b-24___iIkyA`,
	"mB30": `MasterSection-module__m-b-30___yOTB2`,
	"mB32": `MasterSection-module__m-b-32___RVvRT`,
	"mB40": `MasterSection-module__m-b-40___CQ86R`,
	"mT2": `MasterSection-module__m-t-2____shka`,
	"mT3": `MasterSection-module__m-t-3___lNDMj`,
	"mT4": `MasterSection-module__m-t-4___mRHav`,
	"mT5": `MasterSection-module__m-t-5___RlOQd`,
	"mT8": `MasterSection-module__m-t-8___wTpZw`,
	"mT10": `MasterSection-module__m-t-10___hKxHd`,
	"mT15": `MasterSection-module__m-t-15___ZKOn8`,
	"mT16": `MasterSection-module__m-t-16___MKWBJ`,
	"mT20": `MasterSection-module__m-t-20___qkzVZ`,
	"mT22": `MasterSection-module__m-t-22___ipJuH`,
	"mT30": `MasterSection-module__m-t-30___rxPGx`,
	"mT32": `MasterSection-module__m-t-32___bxKoD`,
	"mLAuto": `MasterSection-module__m-l-auto___IVIad`,
	"mL4": `MasterSection-module__m-l-4___EUgty`,
	"mL5": `MasterSection-module__m-l-5___ZpCoQ`,
	"mL6": `MasterSection-module__m-l-6___qULSE`,
	"mL8": `MasterSection-module__m-l-8___WIzB0`,
	"mL10": `MasterSection-module__m-l-10___wvp9K`,
	"mL16": `MasterSection-module__m-l-16___HEKa8`,
	"mL20": `MasterSection-module__m-l-20___zqM_G`,
	"mL24": `MasterSection-module__m-l-24___wv1mZ`,
	"mL30": `MasterSection-module__m-l-30___fYOA1`,
	"mL35": `MasterSection-module__m-l-35___JcBpY`,
	"mL40": `MasterSection-module__m-l-40___eAQoV`,
	"mR8": `MasterSection-module__m-r-8___QgJze`,
	"mR10": `MasterSection-module__m-r-10___w_u5q`,
	"mR16": `MasterSection-module__m-r-16___i2mZZ`,
	"mR20": `MasterSection-module__m-r-20___uN0OF`,
	"mR24": `MasterSection-module__m-r-24___tFEkU`,
	"mR30": `MasterSection-module__m-r-30___jrrHI`,
	"mR40": `MasterSection-module__m-r-40___vSzOv`,
	"borderR3": `MasterSection-module__border-r-3___zsU0Q`,
	"borderR4": `MasterSection-module__border-r-4___UZ_0W`,
	"borderR6": `MasterSection-module__border-r-6___hJ4fT`,
	"borderR10": `MasterSection-module__border-r-10___DPnd6`,
	"borderR12": `MasterSection-module__border-r-12___i66OM`,
	"borderR16": `MasterSection-module__border-r-16___SiIyZ`,
	"borderR50": `MasterSection-module__border-r-50___p32mp`,
	"primaryBorder": `MasterSection-module__primary-border___RMdC_`,
	"primaryBorderB": `MasterSection-module__primary-border-b___nPsTA`,
	"primaryBorderT": `MasterSection-module__primary-border-t___ZT4JX`,
	"primaryBorderL": `MasterSection-module__primary-border-l___YvJfT`,
	"primaryBorderR": `MasterSection-module__primary-border-r___QjYML`,
	"secondaryBorder": `MasterSection-module__secondary-border___J0oXG`,
	"secondaryBorderB": `MasterSection-module__secondary-border-b___h0czq`,
	"secondaryBorderT": `MasterSection-module__secondary-border-t___t9zbg`,
	"secondaryBorderL": `MasterSection-module__secondary-border-l___PPS8N`,
	"secondaryBorderR": `MasterSection-module__secondary-border-r___HC6Ch`,
	"gap0": `MasterSection-module__gap-0___iZqLD`,
	"gap2": `MasterSection-module__gap-2___tPyT_`,
	"gap4": `MasterSection-module__gap-4___x14l8`,
	"gap5": `MasterSection-module__gap-5___fuyVw`,
	"gap6": `MasterSection-module__gap-6___pMKCX`,
	"gap8": `MasterSection-module__gap-8___mdT8t`,
	"gap10": `MasterSection-module__gap-10___WIz90`,
	"gap12": `MasterSection-module__gap-12___mf6m5`,
	"gap14": `MasterSection-module__gap-14___L_32D`,
	"gap16": `MasterSection-module__gap-16___qzbv9`,
	"gap18": `MasterSection-module__gap-18___lUpuk`,
	"gap20": `MasterSection-module__gap-20___RQKNR`,
	"gap24": `MasterSection-module__gap-24___YQG1n`,
	"gap26": `MasterSection-module__gap-26___N55Sz`,
	"gap30": `MasterSection-module__gap-30___ipN8b`,
	"gap32": `MasterSection-module__gap-32___zjFlc`,
	"gap40": `MasterSection-module__gap-40___yEyMD`,
	"gap50": `MasterSection-module__gap-50___u9JfN`,
	"flex1": `MasterSection-module__flex-1___C6wYU`,
	"flexNone": `MasterSection-module__flex-none___f7Pvv`,
	"flexColumn": `MasterSection-module__flex-column___RO4B0`,
	"flexRow": `MasterSection-module__flex-row___GW3om`,
	"verticallyCentered": `MasterSection-module__vertically-centered___qyBuJ`,
	"horizontallyCentered": `MasterSection-module__horizontally-centered___yFGMf`,
	"horizontallyEnd": `MasterSection-module__horizontally-end___qaFtO`,
	"verticallyStart": `MasterSection-module__vertically-start___bAPYg`,
	"spaceBetween": `MasterSection-module__space-between___N0i9w`,
	"flexWrap": `MasterSection-module__flex-wrap___z8Zrj`,
	"height100": `MasterSection-module__height-100___z5usi`,
	"width50": `MasterSection-module__width-50___CR6GA`,
	"width100": `MasterSection-module__width-100___PlTJk`,
	"cursorPointer": `MasterSection-module__cursor-pointer___oqq6l`,
	"cursorNotAllowed": `MasterSection-module__cursor-not-allowed___CqG3s`,
	"absoluteCentered": `MasterSection-module__absolute-centered___p6HNH`,
	"absolute": `MasterSection-module__absolute___D4krU`,
	"relative": `MasterSection-module__relative___uh8wa`,
	"fixed": `MasterSection-module__fixed___j1ssQ`,
	"visible": `MasterSection-module__visible___WhUEp`,
	"invisible": `MasterSection-module__invisible___xzDJ9`,
	"col90": `MasterSection-module__col-90___Qgd7p`,
	"colAuto": `MasterSection-module__col-auto___wr9SW`,
	"medicalTabs": `MasterSection-module__medical-tabs___jt9go`,
	"medicalTableNew": `MasterSection-module__medical-table-new___HORtz`,
	"noPagination": `MasterSection-module__no-pagination___k4cI9`,
	"medicalTableEmpty": `MasterSection-module__medical-table-empty___Ecw6n`,
	"iconBtn": `MasterSection-module__icon-btn___xfp9c`,
	"searchIcon": `MasterSection-module__search-icon___ie3Oy`,
	"disableSelect": `MasterSection-module__disable-select___w9qOc`,
	"breakWord": `MasterSection-module__break-word___EKQza`,
	"popupClearBtn": `MasterSection-module__popup-clear-btn___b6Oig`,
	"scrollMB20": `MasterSection-module__scroll-m-b-20___O0V1U`,
	"container": `MasterSection-module__container___yqnhJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
